import { useState } from 'react';

const BrokerApplicationForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    volume: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6md3g5v117fnkj2h4b0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          volume: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="apply" className="bg-white py-24">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-[#2F6FE4] mb-4">
            Join The Broker Marketplace
          </h2>
          <p className="text-xl text-[#555555]">
            Apply now to access wholesale trade lines and fulfillment services
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-3xl p-12 shadow-xl border-t-4 border-[#3D8BFF]"
          data-readdy-form
        >
          <div className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-semibold text-[#2F6FE4] uppercase mb-2">
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#F2F4F7] border-b-2 border-[#A9C9FF] focus:outline-none focus:border-[#3D8BFF] transition-colors text-[#555555]"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-[#2F6FE4] uppercase mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#F2F4F7] border-b-2 border-[#A9C9FF] focus:outline-none focus:border-[#3D8BFF] transition-colors text-[#555555]"
              />
            </div>

            <div>
              <label htmlFor="phone" className="block text-sm font-semibold text-[#2F6FE4] uppercase mb-2">
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#F2F4F7] border-b-2 border-[#A9C9FF] focus:outline-none focus:border-[#3D8BFF] transition-colors text-[#555555]"
              />
            </div>

            <div>
              <label htmlFor="company" className="block text-sm font-semibold text-[#2F6FE4] uppercase mb-2">
                Company Name
              </label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#F2F4F7] border-b-2 border-[#A9C9FF] focus:outline-none focus:border-[#3D8BFF] transition-colors text-[#555555]"
              />
            </div>

            <div>
              <label htmlFor="volume" className="block text-sm font-semibold text-[#2F6FE4] uppercase mb-2">
                Monthly Client Volume
              </label>
              <select
                id="volume"
                name="volume"
                value={formData.volume}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#F2F4F7] border-b-2 border-[#A9C9FF] focus:outline-none focus:border-[#3D8BFF] transition-colors text-[#555555] cursor-pointer"
              >
                <option value="">Select volume</option>
                <option value="1-5">1-5 clients</option>
                <option value="6-10">6-10 clients</option>
                <option value="11-20">11-20 clients</option>
                <option value="21-50">21-50 clients</option>
                <option value="50+">50+ clients</option>
              </select>
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#2F6FE4] text-white py-4 rounded-full font-bold text-lg hover:bg-[#3D8BFF] transition-all mt-8 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
          >
            {isSubmitting ? 'Submitting...' : 'Apply Now'}
          </button>

          {submitStatus === 'success' && (
            <div className="mt-6 p-4 bg-green-100 text-green-800 rounded-lg text-center">
              Application submitted successfully! We'll contact you soon.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mt-6 p-4 bg-red-100 text-red-800 rounded-lg text-center">
              Something went wrong. Please try again.
            </div>
          )}

          <p className="text-xs text-[#555555] text-center mt-6">
            By submitting this form, you agree to our privacy policy and terms of service.
          </p>
        </form>
      </div>
    </section>
  );
};

export default BrokerApplicationForm;